import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import char from '../../assets/images/intake/step7/char.svg';
import { useEmploymentReadinessContext } from '../../hooks/use-form-context.hooks';
import {
  ProfessionalResourceStatus,
  dispatchUpdateEmploymentReadiness,
} from '../../redux/slice/form-employment-readiness';
import { useAppDispatch } from '../../redux/store';
import logger from '../../services/logger';

interface FormData {
  professionalCoverLetter: string;
}
interface ComponentProps {
  step: number;
  onBack: () => void;
}
const letter_options = [
  {
    label: 'What is a cover letter?',
    value: ProfessionalResourceStatus.WHAT_IS_IT,
  },
  {
    label: 'No',
    value: ProfessionalResourceStatus.NO,
  },
  {
    label: 'I have a cover letter but it’s not very professional',
    value: ProfessionalResourceStatus.UNPROFESSIONAL,
  },
  {
    label: 'I have an outdated cover letter',
    value: ProfessionalResourceStatus.OUTDATED,
  },
  {
    label: 'Yes, I have a professional cover letter',
    value: ProfessionalResourceStatus.YES,
  },
];
export const SampleCover: React.FC<ComponentProps> = ({ step, onBack }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { professionalCoverLetter } = useEmploymentReadinessContext();
  const [selectedCoverLetterOption, setSelectedCoverLetterOption] = useState(
    professionalCoverLetter || '',
  );
  const [error, setError] = useState('');
  const handleCoverLetterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedCoverLetterOption(event.target.value);
    setError('');
  };
  const { handleSubmit } = useForm<FormData>();
  const submitCoverLetterOption: SubmitHandler<FormData> = async () => {
    logger.debug('Submitted professional cover letter form.', selectedCoverLetterOption);

    if (!selectedCoverLetterOption) {
      setError('Please select an option');
    } else {
      const dto: Record<keyof FormData, ProfessionalResourceStatus> = {
        professionalCoverLetter: selectedCoverLetterOption as ProfessionalResourceStatus,
      };
      await dispatch(dispatchUpdateEmploymentReadiness(dto));
      navigate(`/pre-employment/employment-readiness/step${step + 1}`);
    }
  };
  const backButtonClick = () => {
    onBack();
  };

  useEffect(() => {
    if (professionalCoverLetter) {
      setSelectedCoverLetterOption(professionalCoverLetter);
    }
  }, [professionalCoverLetter]);

  return (
    <div>
      <div className="flex items-center mt-9 mb-10 md:px-10">
        <div className="bg-gray-200 p-4 rounded-lg font-semibold mr-5 flex items-center">12</div>
        <div>
          <h4 className="text-2xl">
            I have an updated
            <span className="font-semibold"> professional sample cover letter</span>
          </h4>
        </div>
      </div>
      <div className="character absolute bottom-0 left-[-147px] z-[-10]">
        <img className="" src={char} alt="" />
      </div>
      <form
        className="md:px-10"
        action=""
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={handleSubmit(submitCoverLetterOption)}
      >
        <div className="grid gap-y-3">
          {letter_options.map((option) => (
            <div key={option.label} className="h-[60px]">
              <label className="radio-container h-full p-4 block relative">
                <input
                  checked={selectedCoverLetterOption === option.value}
                  onChange={handleCoverLetterChange}
                  value={option.value}
                  className="w-full h-full absolute top-0 left-0 opacity-0"
                  type="radio"
                  name="resume option"
                />
                <span className="checkmark !block h-auto pt-4">{option.label}</span>
              </label>
            </div>
          ))}
          {error && <p className="text-red-500">{error}</p>}
        </div>
        <div className="flex justify-between mt-20">
          <button
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={handleSubmit(backButtonClick)}
            className="btn-primary"
          >
            Back
          </button>
          <button className="btn-primary">Next</button>
        </div>
      </form>
    </div>
  );
};
